/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../data/localized_addon';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "addons": {
        "nested": {
          "external": {
            "nested": {
              "ListAllAddonsRequest": {
                "fields": {
                  "installedOnly": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "includeWebAddons": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListAllAddonsResponse": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "addon": {
                    "type": ".squareup.addons.data.LocalizedAddon",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "allAddonVerticals": {
                    "type": ".squareup.addons.data.LocalizedVertical",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.ListAllAddonsRequest && !$root.nested?.squareup?.nested?.addons?.nested?.external?.nested?.ListAllAddonsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListAllAddonsRequest @ squareup/addons/external/list_all_addons.proto at 11:1
 */
export const ListAllAddonsRequest = $root.lookupType('squareup.addons.external.ListAllAddonsRequest');
fixType(ListAllAddonsRequest);
Builder.createAndAttachToType(ListAllAddonsRequest);
/**
 * SOURCE ListAllAddonsResponse @ squareup/addons/external/list_all_addons.proto at 19:1
 */
export const ListAllAddonsResponse = $root.lookupType('squareup.addons.external.ListAllAddonsResponse');
fixType(ListAllAddonsResponse, {
  success: {
    required: true
  }
});
Builder.createAndAttachToType(ListAllAddonsResponse);